import { CustomerGenderTypes } from '../../../services/Recognition/Customer/types';

export function getCustomerGenderType(type: CustomerGenderTypes): string {
  switch (type) {
    case CustomerGenderTypes.MALE:
      return 'Masculino';
    case CustomerGenderTypes.FEMALE:
      return 'Feminino';
    case CustomerGenderTypes.OTHER:
      return 'Outro';
    default:
      return 'Não Informado';
  }
}
